import * as c from "../actions/constants";

const initialState = {
  request: null,
  requestsMe: null,
  requestsOther: null,
  requests: null,
  filter: {
    initial: true,
    accepted: true,
    resolving: true,
    resolved: false,
    closed: false,
    dismissed: false,
    textQuery: "",
    limit: 10,
    dateType: "CREATED",
    date: "ANY"
  },
  requestCount: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
      case c.REQUESTS:
      let newState = { ...state, ...action.payload };
      {
          const extra = action.extra;
          if( extra && extra.side )
          {
              // - when is count updated ? Should I update it now?
              // - it does not handle filter for mutiple states at once

              console.log( { action });

              newState.requestCount = newState.requestCount || {}; // initialization?
              newState.requestCount[extra.side] = newState.requestCount[extra.side] || {}; // initialization?
              let p = newState.requestCount[extra.side];
              const filter = extra.filter;

              let count = null;
              if( action.payload.requestsOther && action.payload.requestsOther.count )
              {
                count = action.payload.requestsOther.count;
              }
              else if( action.payload.requestsMe && action.payload.requestsMe.count )
              {
                count = action.payload.requestsMe.count;
              }

              const only = ( statusName ) =>
              {
                let enabledCount = 0;
                for( let status of ["initial", "accepted", "resolving", "resolved", "closed", "dismissed"  ])
                {
                  if( filter[status] )
                  {
                      enabledCount++;
                  }
                }
                if( enabledCount > 1 )
                {
                  return false;
                }
                else
                {
                  return( filter[statusName] );
                }
              };

              if( only( "initial" ))
              {
                  p.initial = count;
              }
              else if( only( "accepted" ))
              {
                  p.accepted = count;
              }
              else if( only( "resolving" ))
              {
                  p.resolving = count;
              }
              else if( only( "resolved" ))
              {
                  p.resolved = count;
              }
              else if( only( "closed" ))
              {
                  p.closed = count;
              }
              else if( only( "dismissed" ))
              {
                  p.dismissed = count;
              }
          }
      }
      return newState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/requestReducer.js